import axios from 'axios';

const makeRequest = async (url, config) => {
    try {
        const response = await axios.get(url, { ...config, cancelToken: new axios.CancelToken(() => { }) });
        return { data: response.data };
    } catch (error) {
        if (axios.isCancel(error)) {
            console.error('Request canceled', error.message);
            return null;
        } else {
            return { err: error.response };
        }
    }
};

export async function GetEmployeeInfo(id, path, filters) {
    const url = `api/employee/${path}/${id}`;
    const config = { params: { filters } };
    return await makeRequest(url, config);
}

export async function GetEmployeePhoto(id) {
    const url = `api/employee/getEmpPhoto/${id}`;
    return await makeRequest(url);
}

export async function GetAllCertificates() {
    const url = `api/ExlCertificateFront/getAllCertificates/`;
    return await makeRequest(url);
}

export async function GetEmployeeCertificates(coaEmpId) {
    const url = `api/ExlCertificateFront/getCertificatesByEmpId`;
    const config = { params: { coaEmpId } };
    return await makeRequest(url, config);
}